import { type SearchRuntimeSortingOption } from '~/apps/product-plus/search-domain/types';
import { toSortSelectionValue } from '~/apps/product-plus/search-domain/utils/toSortSelectionValue';

export function resolveActiveSort(
  indexName: string,
  requestIndexName: string | undefined,
  options: SearchRuntimeSortingOption[],
) {
  const defaultSort = options[0];
  if (!requestIndexName) return defaultSort;

  // Allow aliases/prefixes to vary (e.g. "bet-insights_*"), resolve by stable sort suffix.
  const bySuffix = options.find(sort => requestIndexName.endsWith(toSortSelectionValue(sort)));
  if (bySuffix) return bySuffix;

  return options.find(sort => `${indexName}${toSortSelectionValue(sort)}` === requestIndexName) ?? defaultSort;
}

export function getHitRateBucket(sortField: string) {
  if (!sortField.includes('sportsData.hitRates.last')) return undefined;
  return sortField.split('.').at(-1);
}
